import React from "react"
import clsx from "clsx"
import PageBuilderConstants from "./constants/PageBuilderConstants"
import PageBuilderActions from "./actions/PageBuilderActions"

class RowMenu extends React.Component{

  constructor(props) {
    super(props);
    this.isOpen = this.isOpen.bind(this);
    this._toggleDropdown = this._toggleDropdown.bind(this);
    this._addColumn = this._addColumn.bind(this);
    this._addRow = this._addRow.bind(this);
    this._deleteRow = this._deleteRow.bind(this);
    this._duplicateRow = this._duplicateRow.bind(this);
    this._moveRow = this._moveRow.bind(this);
    this._resizeRow = this._resizeRow.bind(this);
    this._stopPropagation = this._stopPropagation.bind(this);
    this._toggleVisibility = this._toggleVisibility.bind(this);

  };

  /**
  * @returns {boolean}
  */
  isOpen() {
    return this.props.openMenuRowId === this.props.rowId;
  }

  render() {
    var rowMenuClasses = clsx({
      'btn-group': true,
      'btn-group-row': true,
      'menu': true,
      'hidden': this.props.mode !== PageBuilderConstants.COMPOSE || this.props.activeRowId === this.props.rowId
    });

    if (this.props.resizeRowId === this.props.rowId) {
      //resize row menu

      return (
        <div className={rowMenuClasses} ref="menu">
          <button onClick={this._resizeRow.bind(null, null)} type="button" className="btn btn-secondary btn-primary">{I18n.t('save')}</button>
        </div>
      );

    } else {
      //default row menu

      var dropdownStyles = {
        'display': this.isOpen() ? 'block' : 'none'
      };

      var resizeRowClasses = clsx({
        disabled: this.props.columnCount === 1 || this.props.columnCount === 12
      });

      var addColumnClasses = clsx({
        disabled: this.props.columnCount === 12
      });

      return (
        <div className={rowMenuClasses} ref="menu">
          <div className="btn-group">

            <button onMouseEnter={PageBuilderActions.highlightRow.bind(null, this.props.rowId)} onMouseLeave={PageBuilderActions.highlightRow.bind(null, null)} onClick={this._toggleDropdown} type="button" className="btn btn-secondary dropdown-toggle">{I18n.t('row')} <span className="caret"></span></button>

            <ul className="dropdown-menu" style={dropdownStyles}>
              <li onClick={this._resizeRow.bind(null, this.props.rowId)}><a href="#" onClick={this._resizeRow.bind(null, this.props.rowId)} className={resizeRowClasses}><span className="ss-expand"></span> {I18n.t('resize_columns')}</a></li>
              <hr className="dropdown-devider" />
              <li className="dropdown-header">{I18n.t('add_column')}</li>
              <li className="dropdown-add-li" onClick={this._addColumn.bind(null, PageBuilderConstants.LEFT)}><a href="#" onClick={this._addColumn.bind(null, PageBuilderConstants.LEFT)} className={addColumnClasses}><span className="ss-navigateleft"></span> {I18n.t('left')}</a></li>
              <li className="dropdown-add-li" onClick={this._addColumn.bind(null, PageBuilderConstants.RIGHT)}><a href="#" onClick={this._addColumn.bind(null, PageBuilderConstants.RIGHT)} className={addColumnClasses}><span className="ss-navigateright"></span> {I18n.t('right')}</a></li>
              <hr className="dropdown-devider" />
              <li className="dropdown-header">{I18n.t('add_row')}</li>
              <li className="dropdown-add-li" onClick={this._addRow.bind(null, PageBuilderConstants.ABOVE)}><a href="#" onClick={this._addRow.bind(null, PageBuilderConstants.ABOVE)}><span className="ss-navigateup"></span> {I18n.t('above')}</a></li>
              <li className="dropdown-add-li" onClick={this._addRow.bind(null, PageBuilderConstants.BELOW)}><a href="#" onClick={this._addRow.bind(null, PageBuilderConstants.BELOW)}><span className="ss-navigatedown"></span> {I18n.t('below')}</a></li>
            </ul>

            <button onMouseEnter={PageBuilderActions.highlightRow.bind(null, this.props.rowId)} onMouseLeave={PageBuilderActions.highlightRow.bind(null, null)} className="btn btn-secondary" onClick={this._moveRow.bind(null, PageBuilderConstants.UP)}><span className="ss-up"></span></button>
            <button onMouseEnter={PageBuilderActions.highlightRow.bind(null, this.props.rowId)} onMouseLeave={PageBuilderActions.highlightRow.bind(null, null)} className="btn btn-secondary" onClick={this._moveRow.bind(null, PageBuilderConstants.DOWN)}><span className="ss-down"></span></button>

          </div>
        </div>
      );
    }
  }

  _addColumn(direction, event) {
    event.stopPropagation();
    event.preventDefault();
    PageBuilderActions.addColumn(this.props.rowId, direction);
  }

  _addRow(direction, event) {
    event.stopPropagation();
    event.preventDefault();
    PageBuilderActions.addRow(this.props.rowId, direction);
  }

  _deleteRow(event) {
    event.stopPropagation();
    event.preventDefault();
    PageBuilderActions.deleteRow(this.props.rowId);
  }

  _duplicateRow(event) {
    event.stopPropagation();
    event.preventDefault();
    PageBuilderActions.duplicateRow(this.props.rowId);
  }

  _stopPropagation(event) {
    event.stopPropagation();
  }

  _toggleDropdown(event) {
    event.stopPropagation();

    if (this.isOpen()) {
      PageBuilderActions.closeRowMenu(this.props.rowId);
    } else {
      PageBuilderActions.openRowMenu(this.props.rowId);
    }
  }

  _toggleVisibility(device, event) {
    event.stopPropagation();

    PageBuilderActions.toggleVisibility(this.props.rowId, device);
    this.refs.menu.focus()
  }

  _moveRow(direction, event) {
    event.stopPropagation();
    event.preventDefault();
    PageBuilderActions.moveRow(this.props.rowId, direction);
  }

  _resizeRow(rowId, event) {
    event.stopPropagation();
    event.preventDefault();
    PageBuilderActions.resizeRow(rowId);
  }

};

export default RowMenu
